import useWindowSize from '@liveauctioneers/caterwaul-components/lib/hooks/useWindowSize';

import { useAppSelector } from '@/redux/hooks';
import { getInitialWidth } from '@/redux/modules/windowSize';

const useWindowSizeCustom: typeof useWindowSize = (initialSSRWidth) => {
    const initialWidth = useAppSelector(getInitialWidth);

    return useWindowSize(initialSSRWidth || initialWidth);
};

export default useWindowSizeCustom;
